/** Sort options for asset list (value = backend sortBy param). Room/Type covered by filters and location search. */
export const SORT_OPTIONS = [
  { value: 'next_test_date', label: 'Next Test' },
  { value: 'building', label: 'Building' },
  { value: 'equipment_code', label: 'Equipment Code' },
  { value: 'site_name', label: 'Site' },
];

export const ASSET_TYPES = [
  { value: 'exit_light', label: 'Exit Light' },
  { value: 'emergency_light', label: 'Emergency Light' },
  { value: 'rcd', label: 'RCD' },
  { value: 'duress_button', label: 'Duress Button' },
  { value: 'distribution_board', label: 'Distribution Board' },
  { value: 'ceiling_fan', label: 'Ceiling Fan' },
  { value: 'wall_heater', label: 'Wall Heater' },
  { value: 'automated_gate', label: 'Automated Gate' },
  { value: 'external_lighting_control', label: 'External Lighting Control' },
  { value: 'workshop_equipment', label: 'Workshop Equipment' },
  { value: 'emergency_light_test_kit', label: 'Emergency Light Test Kit' },
];

export const ELECTRICAL_ASSET_TYPES = ASSET_TYPES.filter((t) => t.value !== 'workshop_equipment');
export const FITMENTS_ASSET_TYPES = [{ value: 'workshop_equipment', label: 'Workshop Equipment' }];

/** Test frequency in months per asset type — mirrors backend ASSET_TEST_FREQUENCIES. */
export const ASSET_FREQUENCY_MAP = {
  exit_light: 6,
  emergency_light: 6,
  rcd: 12,
  distribution_board: 12,
  ceiling_fan: 12,
  wall_heater: 12,
  external_lighting_control: 12,
  duress_button: 12,
  automated_gate: 6,
  workshop_equipment: 12,
  emergency_light_test_kit: 6,
};

/**
 * Default element / component / item_type for each asset type.
 * Auto-filled on asset type selection; user can override.
 */
export const ASSET_TYPE_DEFAULTS = {
  exit_light:                { element: 'Electrical System', component: 'Emergency Lighting',        itemType: 'EXIT Sign Running Man Light' },
  emergency_light:           { element: 'Electrical System', component: 'Emergency Lighting',        itemType: 'Emergency Light (Built-in Module)' },
  rcd:                       { element: 'Electrical System', component: 'Power',                     itemType: 'RCD / Safety Switch' },
  duress_button:             { element: 'Electrical System', component: 'Access System',             itemType: 'Panic / Duress Button' },
  distribution_board:        { element: 'Electrical System', component: 'Power',                     itemType: 'Distribution Board' },
  ceiling_fan:               { element: 'Electrical System', component: 'Fans & Heaters',            itemType: 'Ceiling Fan' },
  wall_heater:               { element: 'Electrical System', component: 'Fans & Heaters',            itemType: 'Wall Heater' },
  automated_gate:            { element: 'Electrical System', component: 'Access System',             itemType: 'Automated Gate' },
  external_lighting_control: { element: 'Electrical System', component: 'External Security Lighting', itemType: 'External Lighting Control' },
  workshop_equipment: { element: 'Fitments', component: 'Workshop Equipment', itemType: '' },
  emergency_light_test_kit:  { element: 'Electrical System', component: 'Emergency Lighting',        itemType: 'Emergency Light Test Kit' },
};

// Canonical scale lives in shared constants so PDF reports (lib/) can reuse the
// same labels without importing from a feature. Re-exported here to keep the
// existing assets-feature import path stable.
export { CONDITION_RATINGS } from '../../../constants/conditionRatings';
